import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.575 9.484a6.602 6.602 0 0 1 12.85 0A5.101 5.101 0 0 1 17.5 19.6h-11a5.1 5.1 0 0 1-.925-10.116ZM12 5.6a5.402 5.402 0 0 0-5.328 4.517.6.6 0 0 1-.537.5A3.9 3.9 0 0 0 6.5 18.4h11a3.9 3.9 0 0 0 .365-7.783.6.6 0 0 1-.537-.5A5.402 5.402 0 0 0 12 5.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
